import React, { useEffect, useCallback, useState} from 'react';
import {getScripts} from 'decentralized/scripting/scripting.js';
import {connect} from 'react-redux';

const LoadScript = ({code, setCode, isLoading, setIsLoading, scriptType}) => { 
    let [scripts, setScripts] = useState([]);

    useEffect(() => {
        getScripts(scriptType)
            .then(setScripts);
    }, [setScripts, scriptType]);

    const onClickScript = useCallback((script) => {
        setCode('const fn = load(\"' + script.title + '\");\n' + code);
        setIsLoading(false);
    }, [code, setCode, setIsLoading]);


    if (!isLoading) {
        return [];
    }
    return (
        <div className="load-script-flow">
        {scripts.map(
            script =>
                <div
                  onClick={() => onClickScript(script)}
                  className="script-option">
                  {script.title}
                </div>)}
          <div className="load-toolbar">
            <div onClick={() => setIsLoading(false)} className="cancel-btn">
              Cancel
            </div>
          </div>
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoadScript);
